import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';  // Button, Form, Row, Col, Card, Accordion, Tabs, Tab, Badge, Table
import { FaSortUp, FaSortDown } from 'react-icons/fa'; //  FaTrashAlt, FaSave, FaExternalLinkAlt, FaFileUpload
import { IconContext } from "react-icons";

import { AddExperienceBlock } from './AddExperienceBlock';
import { LessonExperiencesTable } from './LessonExperiencesTable';
import { LessonCaptionBlock } from './LessonCaptionBlock';

//import { AuthContext } from '../../context/AuthContext'

import '../css/ContentPages.css';
//import { LessonDatesBlock } from '../client-details/LessonDatesBlock';

export const LessonCard = ({ lesson, array, index, changeLessonIndex, saveLessonNameChanges, pageLanguage, activeLanguage, deleteLesson, deleteExperience, changeExperienceIndex, addExperienceToLesson, dropdownExperiences, editableTable, activeLineEnabled = false, updateLesson = () => { }, setReceivedError, showAllLanguages = false }) => {


    return (
        <div className="CardBlock BoxShadow mb-5" key={lesson.id}>
            <Tabs className="CardBlockHeder" defaultActiveKey="lesson_content">
                {changeLessonIndex !== null && (
                    <Tab
                        tabClassName="CardBlockHederTabArrows"
                        title={
                            <div className="d-flex flex-column ">
                                <IconContext.Provider value={{ color: "#ccc" }}>
                                    {array[index - 1] && <FaSortUp onClick={() => changeLessonIndex(lesson.id, array[index - 1].id)} />}
                                    {array[index + 1] && <FaSortDown onClick={() => changeLessonIndex(array[index + 1].id, lesson.id)} />}
                                </IconContext.Provider>
                            </div>
                        }
                    />)}

                <Tab
                    tabClassName="CardBlockHederTabName"
                    title={<LessonCaptionBlock lesson={lesson} save={saveLessonNameChanges} pagelanguage={pageLanguage} activelanguage={activeLanguage} editableName={editableTable} showAllLanguages={showAllLanguages} />}
                />
                <Tab
                    tabClassName="CardBlockHederTab_Hidden"
                    eventKey="lesson_content"
                    title="Content"
                >
                    <LessonExperiencesTable lesson={lesson} activeLanguage={activeLanguage} deleteExperience={deleteExperience} changeExperienceIndex={changeExperienceIndex} editableContent={editableTable} activeLineEnabled={activeLineEnabled} updateLesson={updateLesson} setReceivedError={setReceivedError} />
                    {editableTable && (
                        <div className='d-flex'>
                            <AddExperienceBlock activeLanguage={activeLanguage} dropdownExperiences={dropdownExperiences} lesson={lesson} addExperienceToLesson={addExperienceToLesson} />
                        </div>)}
                </Tab>
                {deleteLesson !== null && (<Tab
                    tabClassName="CardBlockHederTabTresh CenterLessons"
                    title={
                        <img src="/img/Trash.png" alt="" className="CardBlockHederImgSmall" onClick={() => {
                            if (window.confirm('Delete this lesson? ATTENTION: It will remove this lesson from the *Lessons List* avaliable to clients (1), from the *Teams* that use this lesson (2), and it will remove all *Custom Quizzes* created by client`s moderators for experiences of this lesson (3). Connected to this lesson *Experiences* will stay safe in Experiences section.')) {
                                deleteLesson(lesson.id)
                            }
                        }} />
                    }
                />)}
                {
                /*<Tab
                    tabClassName="CardBlockHederTab"
                    title={
                        <LessonDatesBlock lesson={lesson} setNewDates={setNewDates} />
                    }
                />
                */}
            </Tabs>
        </div >
    );
}
